import "./Navbar.css";
import "react-dropdown/style.css";

const Navbar = () => {
	return (
		<nav className="navbar-container">
				<p>Create a card</p>
		</nav>
	);
};

export default Navbar;
